import React from 'react';

import { useOnlineStatus } from 'contexts/OnlineStatusProvider';
import { useAuthContext } from 'contexts/AuthProvider';
import useToggleOnline from 'hooks/useToggleOnline';

import Switch from 'components/core/Switch';

const OnlineToggle: React.FC = () => {
  const { session } = useAuthContext();

  const { online } = useOnlineStatus();
  const [toggleOnline, { loading }] = useToggleOnline();

  if (!session) return null;

  return (
    <Switch
      checked={online}
      disabled={loading}
      onChange={() => toggleOnline(!online)}
    />
  );
};

export default OnlineToggle;
